import { parentNode } from './parent-node';

export const recursiveClosest = (selector: string, currentElement: Node) => {
  const isMatching = Element.prototype.matches.call(currentElement, selector);

  if (isMatching) {
    return currentElement;
  }

  const nextElement = parentNode(currentElement);

  if (nextElement === null) {
    return null;
  }

  return recursiveClosest(selector, currentElement);
};
